export const BASE_URL = 'https://www.vikramshilaedu.in/';
export const BASE_APP = 'https://www.vikramshilaedu.in';
export const SERVER_URL = "https://www.vikramshilaedu.in";
